module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image04-309fc1558e1f981bbc8dbffa91458d05.png";